// Apart from ComplianceTable because the operators route checks its URL with these, and
// a route's search check is part of the bundle every page loads.

/** The compliance table's columns, which the operators page can sort by. */
export const sortKeys = ["operator", "score", "fleet", "papers", "trips", "complaints", "digital", "onTime"] as const;

export type SortKey = (typeof sortKeys)[number];
export type SortDir = "asc" | "desc";
